
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAisTargetSleepingNohdgcogIec as ObiAisTargetSleepingNohdgcogIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ais-target-sleeping-nohdgcog-iec.js';
 
 
 

 
 export const ObiAisTargetSleepingNohdgcogIec = createComponent({
   react: React,
   tagName: 'obi-ais-target-sleeping-nohdgcog-iec',
   elementClass: ObiAisTargetSleepingNohdgcogIecElement,
   events: {
     
   }
  });
 
 